module.exports = __webpack_public_path__ + "img/block_2.baa3163a.webp";